import { sharedEnvironment } from "../../../config/environmentService";
import { getMediaStreamingUrl } from "../../../utils/getMediaStreamingUrl";

const CLOUDFRONT_MEDIA_BUCKET_URL = sharedEnvironment.defaultMediaStreamingDistributionUrl;

// Add the images o s3 "dynamic-streaming-media" bucket.
const CLOUDFRONT_ASSETS = {
  images: {
    emptyScene: "empty-scene.png",
    sideContentLayoutImage1: "side-content-layout-image-1.png",
    sideContentLayoutImage2: "side-content-layout-image-2.png",
    sideContentLayoutImage3: "side-content-layout-image-3.png",
    sideContentLayoutImage4: "side-content-layout-image-4.png",
  },
} as const;

function getAssetFromCloudfront(name: keyof typeof CLOUDFRONT_ASSETS.images) {
  const slug = `https://${CLOUDFRONT_MEDIA_BUCKET_URL}/images/${CLOUDFRONT_ASSETS["images"][name]}`;
  return getMediaStreamingUrl(slug);
}

export { getAssetFromCloudfront };
